<app-dialog-header
	[title]="'changePartition.dialog.title'"
	variant="alert"
	(closeClick)="close()"
></app-dialog-header>

<div>
	<mat-dialog-content class="center-block">
		<h4 class="ps-sm-5 text-sm-start">{{ "changePartition.dialog.message" | translate }}</h4>
		<br />
		<div class="d-flex text-center justify-content-center gap-3">
			<a
				(click)="close()"
				class="btn btn-outline text-uppercase"
			>
				<i
					class="fa fa-times"
					style="padding-right: 8px"
				></i>
				{{ "changePartition.dialog.close" | translate }}
			</a>
			<a
				(click)="ok()"
				class="btn btn-blue text-uppercase"
			>
				<i
					class="fa fa-envelope"
					style="padding-right: 8px"
				></i>
				{{ "changePartition.dialog.ok" | translate }}
			</a>
		</div>
	</mat-dialog-content>
</div>